import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { GeopointWidgetComponent } from './geopoint-widget.component';

@NgModule({
    declarations: [GeopointWidgetComponent],
    exports: [GeopointWidgetComponent],
    imports: [SharedModule],
})
export class GeopointWidgetModule {}
